/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';

import { Grid } from 'semantic-ui-react';

import { VariationWrapper } from 'iovisit-theme/components';
import Card from 'iovisit-theme/components/Blocks/Listing/CardsTemplate/Card';

const CardsVariations = (data) => {
  const { items } = data;

  return (
    <VariationWrapper {...data} variation="cards">
      <Grid stackable>
        {items.map((item, index) => (
          <Grid.Column
            tablet={12}
            computer={6}
            widescreen={4}
            largeScreen={4}
            key={index}
          >
            <Card {...data} item={item} />
          </Grid.Column>
        ))}
      </Grid>
    </VariationWrapper>
  );
};

export default CardsVariations;
